import { Component, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-signs',
  templateUrl: './admin-signs.component.html',
  styleUrls: ['./admin-signs.component.css']
})
export class AdminSignsComponent implements OnInit {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  signs: any[] = [];
  cols: any[];
  types: SelectItem[] = [];
  formdata;
  display = false;
  displayaddsign = false;
  result = '';
  subscriptions: Subscription[] = [];
  value: any;

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {

    this.cols = [
      { field: 'abbreviation', header: 'Förkortning' },
      { field: 'name', header: 'Namn' },
      { field: 'typeName', header: 'Typ' },
      { field: 'sort', header: 'Sortering' }
    ];
    this.getSigns();
  }


  getSigns() {
    this.adminService.GetSigns().subscribe(resp => {
      if (resp) {
        this.signs = resp;
        this.getSignTypes();
      }
    });
  }

  getSignTypes() {
    this.adminService.GetSignTypes().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.name, value: d.id
          };
          this.types.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.types.unshift(emptyrecord);
      }
    });
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  saveSign(evt) {
    this.adminService.UpdateSign(evt).subscribe(x => {
      this.display = false;
      this.getSigns();
    });
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Bekräfta radering',
      message: 'Vill du radera vald utmärkelse?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.deleteSign(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteSign(rowdata) {
    this.adminService.RemoveSign(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Utmärkelse raderad.' });
        this.getSigns();
      }
      error => {
        console.log(error.message);
      }
    });
  }

  cancelEdit() {
    this.display = false;
  }

  addSign() {
    this.displayaddsign = true;
  }

  saveAddSign(evt) {
    this.adminService.AddSign(evt).subscribe(resp => {
      if (resp) {
        this.displayaddsign = false;
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Utmärkelse tillagd.' });
        this.getSigns();
      }
    });
  }

  cancelAdd() {
    this.displayaddsign = false;
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }

  exportToCSV() {
    let firstrow = '';
    this.cols.forEach(c => {
      firstrow += c.header + ';';
    });
    const filnamn = 'OF_signs';

    const excelrecords: any[] = [];
    this.signs.forEach(r => {
      const row = {
        abbreviation: r.abbreviation,
        name: r.name,
        typeName: r.typeName,
        sort: r.sort
      }
      excelrecords.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);
  }
}
